import {role} from '@/api-services'
import {paginationHandler, parseLinkHeader} from '@/utils/common'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useRoleStore = defineStore('roleStore', {
  state: () => ({
    allRoles: [],
    roleDetail: {},
    loading: false,
    error: null,
    rolesList: [],
    rolesListLink: {},
    rolesListLoading: false,
  }),
  getters: {
    getAllRolesWithSerialNumber() {
      return this.allRoles.map((val, index) => ({
        ...val,
        serialNumber: index + 1,
      }))
    },

    getFilteredRole() {
      return this.allRoles.filter((val) => (val.name !== 'user' && val.name !== 'lawyer' && val.name !== 'super_admin'))
    },
  },
  actions: {
    async getAllRoles() {
        this.loading = true
        try {
        const response = await role.getRoles()
        const data = response.data
        this.allRoles = data
        this.rolesList = data
        this.rolesListLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getRoleById(id) {
        this.loading = true
        try {
        const response = await role.getRoleById(id)
        const data = response.data
        this.roleDetail = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async postRole(payload) {
        this.loading = true
        try {
        const response = await role.postRoles(payload)
        const data = response.data
        this.roleDetail = data
        toast.success(successHandler('CREATE_ROLE_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async deleteRole(id) {
        this.loading = true
        try {
        await role.deleteRole(id)
        toast.success(successHandler('DELETE_ROLE_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getTablePagination(page, type=null) {
      if (type) {
        this[`${type}Loading`] = true
      } else {
        this.loading = true
      }
      let response = []
      try {
        if (page === 'next') {
          response = await paginationHandler(this[`${type}Link`].next)
        } else if (page === 'prev') {
          response = await paginationHandler(this[`${type}Link`].prev)
        }
        this[type] = response.data
        if (type) {
          this[`${type}Link`] = parseLinkHeader(response.headers.link)
        } else {
          this.link = parseLinkHeader(response.headers.link)
        }
      } catch (error) {
        const errorMsg = errorHandler(error)
        this.error = errorMsg
        toast.error(errorMsg)
      } finally {
        if (type) {
          this[`${type}Loading`] = false
        } else {
          this.loading = false
        }
      }
    },

    async getNextPage(data) {
      const {value} = data
      try {
        const response = await paginationHandler(this.rolesListLink.next)
        this.allRoles = [...value, ...response.data]
        this.rolesListLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      }
    },
  },
})
